import { CustomColumn } from '@/common/utils';
import { InstanceV9ItemInstanceRole } from '@/api-client/metav8Over/model';

export const AGENT_STATUS = {
  connect: 'Connect',
  connecting: 'Connecting',
  noSignal: 'No Signal',
};

const instanceGroupIdColumn: CustomColumn = {
  caption: 'Instance ID',
  field: 'instanceId',
  type: 'string',
  hide: true,
  searchable: false,
};
const instanceGroupNameColumn: CustomColumn = {
  caption: 'Instance Group Name',
  field: 'instanceGroupName',
  type: 'string',
  hide: true,
  width: 150,
  searchable: false,
};
const instanceNameColumn: CustomColumn = {
  caption: 'Instance Name',
  field: 'instanceName',
  type: 'string',
  width: 210,
  clickable: true,
  searchable: true,
  defaultSearchField: true,
};
const connectionInfoColumn: CustomColumn = {
  caption: 'Connection Info',
  field: 'hostName',
  type: 'string',
  width: 130,
  searchable: true,
};
const osColumn: CustomColumn = {
  caption: 'OS',
  field: 'os',
  type: 'string',
  width: 100,
  searchable: true,
};
const databaseNameColumn: CustomColumn = {
  caption: 'Database Name',
  field: 'databaseName',
  type: 'string',
  width: 150,
  searchable: true,
};
const databaseVersionColumn: CustomColumn = {
  caption: 'Database Version',
  field: 'databaseVersion',
  type: 'string',
  width: 130,
  searchable: true,
};
const dbAgentStatusColumn: CustomColumn = {
  caption: 'DB Agent Status',
  field: 'status',
  type: 'string',
  align: 'center',
  width: 100,
  rendererType: 'label',
  searchable: true,
};
const descriptionColumn: CustomColumn = {
  caption: 'Description',
  field: 'description',
  type: 'string',
  width: 180,
  searchable: true,
};
const aliasNameColumn: CustomColumn = {
  caption: 'Alias',
  field: 'alias',
  type: 'string',
  width: 210,
  searchable: true,
  defaultSearchField: true,
};
const portColumn: CustomColumn = {
  caption: 'Port',
  field: 'port',
  type: 'stringNumber',
  width: 70,
  searchable: true,
};
const clusterColumn: CustomColumn = {
  caption: 'Cluster:Role',
  field: 'clusterRole',
  type: 'string',
  width: 110,
  searchable: true,
};
const cmsIpColumn: CustomColumn = {
  caption: 'Connection Info',
  field: 'cmsIp',
  type: 'string',
  width: 150,
  searchable: true,
};
const databaseEngineColumn: CustomColumn = {
  caption: 'Database Engine',
  field: 'dbEngineInfo',
  type: 'string',
  width: 120,
  searchable: true,
};
const dbCollectEnableColumn: CustomColumn = {
  caption: 'Collect Enable(DB)',
  field: 'dbCollectEnabled',
  type: 'string',
  width: 120,
  align: 'center',
  searchable: false,
};
const cloudCollectEnableColumn: CustomColumn = {
  caption: 'Collect Enable(Cloud)',
  field: 'cloudCollectEnabled',
  type: 'string',
  width: 120,
  align: 'center',
  searchable: false,
};
const instanceMonitoringEnableColumn: CustomColumn = {
  caption: 'Monitoring Enable(DB)',
  field: 'enable',
  type: 'string',
  hide: true,
  searchable: false,
};
const osMonitoringEnableColumn: CustomColumn = {
  caption: 'Monitoring Enable(Cloud)',
  field: 'osEnable',
  type: 'string',
  hide: true,
  searchable: false,
};
const databaseListColumn: CustomColumn = {
  caption: 'Database List',
  field: 'databaseList',
  type: 'string[]',
  width: 120,
  align: 'center',
};

export const allDbGridColumns = [
  instanceNameColumn,
  aliasNameColumn,
  instanceGroupIdColumn,
  {
    ...instanceGroupNameColumn,
    width: 160,
    hide: false,
    searchable: true,
  },
  clusterColumn,
  connectionInfoColumn,
  osColumn,
  databaseNameColumn,
  databaseEngineColumn,
  databaseVersionColumn,
  {
    ...dbAgentStatusColumn,
    hide: true,
  },
  descriptionColumn,
];

export const dbGridColumns = [
  instanceNameColumn,
  aliasNameColumn,
  dbAgentStatusColumn,
  // cloudAgentStatusColumn,
  instanceGroupIdColumn,
  instanceGroupNameColumn,
  clusterColumn,
  connectionInfoColumn,
  osColumn,
  databaseNameColumn,
  databaseEngineColumn,
  databaseVersionColumn,
  dbCollectEnableColumn,
  cloudCollectEnableColumn,
  descriptionColumn,
  instanceMonitoringEnableColumn,
  osMonitoringEnableColumn,
];

export const postgresGridColumns = [
  instanceNameColumn,
  aliasNameColumn,
  dbAgentStatusColumn,
  // cloudAgentStatusColumn,
  instanceGroupIdColumn,
  instanceGroupNameColumn,
  clusterColumn,
  connectionInfoColumn,
  osColumn,
  databaseListColumn,
  databaseNameColumn,
  databaseEngineColumn,
  databaseVersionColumn,
  dbCollectEnableColumn,
  cloudCollectEnableColumn,
  descriptionColumn,
  instanceMonitoringEnableColumn,
  osMonitoringEnableColumn,
];

export const redisGridColumns = [
  instanceNameColumn,
  aliasNameColumn,
  dbAgentStatusColumn,
  // cloudAgentStatusColumn,
  instanceGroupIdColumn,
  instanceGroupNameColumn,
  clusterColumn,
  { ...databaseNameColumn, caption: 'DB Name', width: 80 },
  connectionInfoColumn,
  portColumn,
  osColumn,
  databaseEngineColumn,
  databaseVersionColumn,
  dbCollectEnableColumn,
  cloudCollectEnableColumn,
  descriptionColumn,
  instanceMonitoringEnableColumn,
  osMonitoringEnableColumn,
];

export const cubridGridColumns = [
  instanceNameColumn,
  aliasNameColumn,
  dbAgentStatusColumn,
  clusterColumn,
  cmsIpColumn,
  osColumn,
  databaseNameColumn,
  databaseEngineColumn,
  databaseVersionColumn,
  dbCollectEnableColumn,
  cloudCollectEnableColumn,
  descriptionColumn,
  instanceMonitoringEnableColumn,
  osMonitoringEnableColumn,
];

export const mongoGridColumns = [
  instanceNameColumn,
  aliasNameColumn,
  dbAgentStatusColumn,
  clusterColumn,
  connectionInfoColumn,
  osColumn,
  databaseNameColumn,
  databaseEngineColumn,
  databaseVersionColumn,
  dbCollectEnableColumn,
  cloudCollectEnableColumn,
  descriptionColumn,
  instanceMonitoringEnableColumn,
  osMonitoringEnableColumn,
];

export const redshiftGridColumns = [
  instanceNameColumn,
  aliasNameColumn,
  clusterColumn,
  dbAgentStatusColumn,
  connectionInfoColumn,
  osColumn,
  databaseNameColumn,
  databaseEngineColumn,
  databaseVersionColumn,
  dbCollectEnableColumn,
  cloudCollectEnableColumn,
  descriptionColumn,
];

export const INSTANCE_ROLE: Record<string, InstanceV9ItemInstanceRole> = {
  SINGLE_STORE_CLUSTER_NODE: 'SINGLE_STORE_CLUSTER_NODE',
  SINGLE_STORE_CLUSTER_INSTANCE: 'SINGLE_STORE_CLUSTER_INSTANCE',
  PG_CLUSTER_DATABASE: 'PG_CLUSTER_DATABASE',
  PG_CLUSTER_INSTANCE: 'PG_CLUSTER_INSTANCE',
  NONE: 'NONE',
};
